import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

Vue.use(Viewer);

import VueRouter from "vue-router";

import '@fortawesome/fontawesome-free/css/all.min.css';

import { routes } from "@/router";

import instance from "@/axios/axios-global";

import Lightbox from 'vue-easy-lightbox'

import { VueUtil } from './components/common/VueUtils'
Vue.mixin(VueUtil);
import VueExcel from './components/common/VueExcel'
Vue.prototype.$VueExcel = VueExcel;
Vue.component('VueExcel', VueExcel);

import Toasted from 'vue-toasted';
import toast from "@/components/common/toast";
import { decryptUtil, encryptUtil } from "./Utils/decrypt";
Vue.prototype.$decryptUtil = decryptUtil;
Vue.prototype.$encryptUtil = encryptUtil;

import { installContentProtection } from "./Utils/contentProtection";
installContentProtection();

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Toasted)
Vue.use(Lightbox)


Vue.prototype.$isIndigo = localStorage.getItem('isIndigo')

// Strict boolean on purpose. localStorage hands back strings, so the legacy
// $isIndigo above is the string "false" for non-Indigo partners - which is
// truthy. $uberFlow is coerced once here so `v-if="$uberFlow"` is always safe.
Vue.prototype.$uberFlow = localStorage.getItem('uberFlow') === 'true'


const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
});

router.beforeEach(
    (to, from, next) => {
        let retrievedObject = localStorage.getItem('vendorLoginToken');
        let vendorLoginStatus = localStorage.getItem('vendorStatus')

        // Routes that declare auth:false are reachable signed in or out - the
        // shareable ride link is opened by crew who have no account here. Only
        // /login carried this flag until now, so nothing existing changes.
        const isPublic = to.meta && to.meta.auth === false;

        if (retrievedObject === null) {
            if (to.path === '/login' || isPublic) {
                next()
            } else {
                router.push('/login')
                next()
            }
        } else {
            // if(to.path)
            if (to.path === '/login') {
                router.push('/dashboard')
                next()
            } else if (to.path === '/') {
                router.push('/dashboard')
                next()
            }
            next()
        }

    }
)

instance.interceptors.response.use((response) => {
    // if (response.status === 401) {
    //     instance.defaults.headers.common['token'] = "";
    //
    //     localStorage.removeItem('vendorLoginToken')
    //     localStorage.removeItem('vendorName')
    //     localStorage.removeItem('vendorNumber')
    //     localStorage.removeItem('vendorStatus')
    //
    //     this.$router.push('/login')
    // }
    return response;
}, error => {
    // Guarded: a request that never got a response has no `.status`, and
    // reading it threw a TypeError that replaced the real failure.
    if (error.response && error.response.status === 401) {
        instance.defaults.headers.common['token'] = "";

        localStorage.removeItem('vendorLoginToken')
        localStorage.removeItem('vendorName')
        localStorage.removeItem('vendorNumber')
        localStorage.removeItem('vendorStatus')
        localStorage.removeItem('ownerId')

        router.push('/login')
    }

    /*
     * Re-reject, always.
     *
     * Returning nothing from an error handler RESOLVES the chain with undefined,
     * so every non-401 failure reached its caller as a success carrying no
     * response. `await axios.post(...)` then handed back undefined and the next
     * line - typically `response.data` - threw "Cannot read properties of
     * undefined (reading 'data')", which is the error the caller reported
     * instead of the server's own message.
     */
    return Promise.reject(error)
})


new Vue({
    vuetify,
    router,
    render: function (h) {
        return h(App)
    }
}).$mount('#app')
